import Tabs from '@/views/tabs';

let swiper = null;

const ARTICLE_SELECTOR = 'article.v4.storable-types-tabs';

$(document).on('turbolinks:load', async () => {
  const node = document.querySelector(ARTICLE_SELECTOR);
  if (!node) { return; }

  const [{ default: Swiper }, { EffectFade, Pagination }] = await Promise.all([
    import('swiper'),
    import('swiper/modules')
  ]);

  const paginationData = $('.swiper', node).data('pagination');
  const tabs = $('.b-tabs', node).toArray().map(node => new Tabs(node));

  swiper = new Swiper($('.swiper', node)[0], {
    modules: [EffectFade, Pagination],
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide',
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: $('.b-tabs .inner', node)[0],
      clickable: true,
      bulletActiveClass: 'is-active',
      bulletClass: 'tab',
      renderBullet: (index, className) => (
        `<div class="tab ${paginationData[index][0]} ${className}">` +
          `<span>${paginationData[index][1]}</span></div>`
      )
    },
    on: {
      afterInit: () => {
        syncTabs(tabs);
        tabs.forEach(tab => tab.insertMarker());
      },
      slideChange: () => {
        syncTabs(tabs);
        tabs.forEach(tab => tab.syncMarker());
      }
    }
  });

  $('.show-more', node).on('click', ({ currentTarget }) => {
    $(currentTarget).closest('.swiper-slide').addClass('is-expanded');
  });

  $('.tab', tabs[1].node).on('click', ({ currentTarget }) => (
    swiper.slideTo($(currentTarget).index())
  ));
});

pageUnload('pages_root', () => {
  if (swiper) {
    swiper.destroy();
    swiper = null;
  }
});

function syncTabs(tabs) {
  const index = $(`${ARTICLE_SELECTOR} .swiper-slide:first-child .tab.is-active`)
    .index();

  const $tabs = $(`${ARTICLE_SELECTOR} .swiper-slide:last-child .tab`);

  $tabs.removeClass('is-active');
  $tabs.eq(index).addClass('is-active');
}
